import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { usePageViewLogger } from '@framework/action-log';
import { LoginForm } from '@user/Login';
import { useCurrentUserEntity } from '@user/UserEntity/useCurrentUserEntity';
import { SimpleFooterLayout } from '@user/layouts/SimpleFooterLayout';
import BalusLogo from '@assets/balus-logo-brand-horizontal.svg';
import { useTranslation } from 'react-i18next';

export const LoginPage: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const currentUserEntity = useCurrentUserEntity();
  const pageViewLogger = usePageViewLogger('LoginPage');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (currentUserEntity) return;

    pageViewLogger.landing();
    return () => pageViewLogger.leaving();
  }, [currentUserEntity, pageViewLogger]);

  const requestPath = searchParams.get('requestPath') || '/';

  // 既にログイン済みであれば、ログインフォームを表示するのではなく、元のリクエストパス (or HomePage) にリダイレクトする
  return currentUserEntity ? (
    <Navigate to={requestPath} replace />
  ) : (
    <SimpleFooterLayout>
      <div className="mx-auto flex flex-col items-center px-4 pb-8 pt-16 md:container">
        <img src={BalusLogo} className="w-64" />
        <div className="py-8 text-4xl font-bold">{t('auth.login.title')}</div>
        <LoginForm />
      </div>
    </SimpleFooterLayout>
  );
};
